import Subscribe from "components/Subscribe";
import type { SubscribeProps } from "components/Subscribe/Subscribe.d";
import type { ReactStoryblokComponent } from "types/storyblok";

const SubscribeAdapter = ({
  blok: { heading, text, buttonText, listId },
  sbEditable,
}: ReactStoryblokComponent<SubscribeProps>) => (
  <Subscribe heading={heading} text={text} buttonText={buttonText} listId={listId} sbEditable={sbEditable} />
);

export default SubscribeAdapter;
